import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";

@Component({
  selector: 'fb-product-description',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss']
})
export class ProductDescriptionComponent {

	@Input()
	public product: Product = {} as Product;

}
